import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const SendIcon = (properties: iconType) => (
  <SvgIcon {...properties} viewBox="0 0 16 20" style={{ width: '16px', height: '19px' }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#969696"
      stroke="none"
      d="M3 12.667L3 10.0003L8.71429 10.0003L8.71429 12.667L3 12.667Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#969696"
      stroke="none"
      d="M13 11.3334L7.28571 8.00008L7.28571 14.6667L13 11.3334Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#969696"
      stroke="none"
      d="M1.58333 20H14.25C15.1208 20 15.8333 19.2742 15.8333 18.3871V7.95161C15.8333 7.51613 15.675 7.1129 15.3742 6.80645L9.15167 0.467741C8.85083 0.161291 8.455 0 8.0275 0H1.58333C0.7125 0 0 0.725807 0 1.6129V18.3871C0 19.2742 0.7125 20 1.58333 20ZM0.632324 1.61307C0.632324 1.08081 1.05982 0.645325 1.58232 0.645325H8.02649C8.27982 0.645325 8.51732 0.7421 8.69149 0.935648L14.914 7.27436C15.104 7.45178 15.199 7.69371 15.199 7.95178V18.3873C15.199 18.9195 14.7715 19.355 14.249 19.355H1.58232C1.05982 19.355 0.632324 18.9195 0.632324 18.3873V1.61307Z"
    />
  </SvgIcon>
);

export default SendIcon;
